
import React, { createContext, useContext } from 'react';
import { useAuthService } from '@/hooks/useAuthService';
import { AuthContextType } from '@/types/auth';
import { getUserDisplayName, getUserAvatar } from '@/utils/userUtils';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuthService();
  
  // Add user utility functions to the auth context
  const value: AuthContextType = {
    ...auth,
    getUserDisplayName: () => getUserDisplayName(auth.user, auth.profile),
    getUserAvatar: () => getUserAvatar(auth.user, auth.profile),

  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
